import React from 'react';

export default function Chat() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <path d="M17.74,3.44A4.17,4.17,0,0,0,14.42.29,51.65,51.65,0,0,0,9,0,51.65,51.65,0,0,0,3.58.29,4.22,4.22,0,0,0,.24,3.44,27.36,27.36,0,0,0,0,7.08a26.54,26.54,0,0,0,.24,3.57,4.19,4.19,0,0,0,3.34,3.14c.52.06,1,.09,1.56.13v3.41a.68.68,0,0,0,.38.63,1.1,1.1,0,0,0,.27,0,.59.59,0,0,0,.44-.19L10.06,14c1.45,0,2.9-.11,4.36-.25a4.06,4.06,0,0,0,3.32-3.06A23.71,23.71,0,0,0,18,7.06,24.3,24.3,0,0,0,17.74,3.44Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/icons/Chat/index.js